import { getFirebase } from 'react-redux-firebase';
import { applyMiddleware, createStore as reduxCreateStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
//Middleware
import thunk from 'redux-thunk';

import analytics from './analytics';
// Routing
import createRootReducer from './modules';

/**
 * App initial state
 */
const initialState = {};

/**
 * Redux enhancers
 */
const enhancers = [];

/**
 * Redux middleware
 */
const middleware = [thunk.withExtraArgument(getFirebase), analytics()];

/**
 * Composed enhancers with dev tools
 */
const composedEnhancers = composeWithDevTools(
  applyMiddleware(...middleware),
  ...enhancers
);

/**
 * Redux store
 */
const createStore = () =>
  reduxCreateStore(createRootReducer(), initialState, composedEnhancers);

export default createStore;
